import React, { useEffect, useState } from 'react'
import MenuPublicApi from '../../api/MenuPublicApi';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
import { HuongDan } from '../huongdan/HuongDan';
import { GopY } from '../gopy/GopY';

export const Menu = (props) => {
    const [listMenus, setlistMenu] = useState([]);
    const [count, setCount] = useState(0);
    const [showHuongDan, setShowHuongDan] = useState(false);
    const [selectMenu, setSelectMenu] = useState('');
    const [showGopY, setShowGopY] = useState(false);

    const loadMenu = async () => {
        let list = [];
        list = await MenuPublicApi.getAll();
        list = list.filter(x => x.Code === 1);
        setlistMenu(list);
    }

    useEffect(() => {
        loadMenu();
    }, []);

    const clickLink = (item) => {
        props.clickMenu({ url: item.Url, id: count });
        setCount(count + 1);
        setSelectMenu(item.Url);
        $('a.nav-link').each(function (index) {
            if (!$(this).hasClass('collapsed')) {
                $(this).addClass('collapsed')
                $('.navbar-nav').addClass('toggled')
            }
        });
        $('div.collapse').each(function () {
            if ($(this).hasClass('show')) {
                $(this).removeClass('show')
            }
        });
    }

    const clickHuongDan = () => {
        setSelectMenu('HUONGDAN');
        setShowHuongDan(true);
    }

    const clickGopY = () => {
        setSelectMenu('GOPY');
        setShowGopY(true);
    }

    return (
        <>
            <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled" id="accordionSidebar">
                <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/">
                    <div className="sidebar-brand-icon">
                        <img className="logo" src="/img/logo.png" alt='logo'></img>
                    </div>
                    <div className="sidebar-brand-text mx-3">Bản dồ</div>
                </a>
                <hr className="sidebar-divider" />
                <div key='trangchu'>
                    <li className="nav-item">
                        <a href='https://bandothonhuongchupuh.gialai.gov.vn:1001' className="nav-link collapsed">
                            <i className='fa fa-home' />
                            <span>Trang chủ</span>
                        </a>
                    </li>
                    <hr className="sidebar-divider" />
                </div>
                {
                    listMenus.filter(x => x.ParentId === null).map((item, key) => {
                        let listChil = listMenus.filter(x => x.ParentId === item.Id);
                        if (listChil.length === 0) {
                            return (
                                <div key={key}>
                                    <li className="nav-item">
                                        <NavLink to={item.Url} className="nav-link collapsed">
                                            <i className={item.Icon} />
                                            <span>{item.Name}</span>
                                        </NavLink>
                                    </li>
                                    <hr className="sidebar-divider" />
                                </div>
                            )
                        }
                        return (
                            <div key={key}>
                                <li className="nav-item">
                                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target={'#menu' + key} aria-expanded="true" aria-controls={'menu' + key}>
                                        <i className={item.Icon} />
                                        <span>{item.Name}</span>
                                    </a>
                                    <div id={'menu' + key} className="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
                                        <div className="bg-white py-2 collapse-inner rounded">
                                            <h6 className="collapse-header">{item.Name}</h6>
                                            {
                                                listChil.map((child, index) => {
                                                    return (
                                                        <li onClick={() => clickLink(child)} className="collapse-item" key={index}>{child.Name}</li>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </li>
                                <hr className="sidebar-divider" />
                            </div>
                        )
                    })
                }
                <li className="nav-item">
                    <li className="nav-link collapsed" onClick={() => clickGopY()}>
                        <i className="fas fa-comment-dots" />
                        <span>Góp ý</span>
                    </li>
                </li>
                <hr className="sidebar-divider" />
                <li className="nav-item">
                    <li className="nav-link collapsed" onClick={() => clickHuongDan()}>
                        <i className="fas fa-question-circle" />
                        <span>Hướng dẫn</span>
                    </li>
                </li>
            </ul>
            {
                selectMenu === 'HUONGDAN' ? <HuongDan show={showHuongDan} handleClose={() => setShowHuongDan(false)}></HuongDan> : ''
            }
            {
                selectMenu === 'GOPY' ? <GopY show={showGopY} handleClose={() => setShowGopY(false)}></GopY> : ''
            }
        </>
    )
}
